<template>
  <div>
    <el-container class="padding">
      <el-form inline>
        <el-form-item label="經銷商">
          <selectCompany :id.sync="company_id" @onSelect="onSelectCompany" />
        </el-form-item>
      </el-form>
      <el-button v-if="selected.length" type="danger" @click="deleteInvoices"> 刪除 </el-button>
    </el-container>

    <!-- {{ invoices }} -->
    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="invoices.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <el-table :data="invoices.rows" style="width: 100%" :row-class-name="statusClass" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="Period" label="期別" width="80" />
      <el-table-column prop="Front" label="字軌編號" />
      <el-table-column prop="Number" label="發票號碼" sortable="" />
      <el-table-column label="開立狀態" prop="Status">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status ? 'success' : 'danger'">
            {{ scope.row.Status ? '未開立' : '已開立' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="invoices.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog title="發票明細" :visible.sync="dialogVisible" width="30%">
      <h3>品名: {{ invoiceDetail.productName }}</h3>
      <h3>單價: {{ invoiceDetail.unityPrice }}</h3>
      <h3>支付方式: {{ invoiceSale.PayType }}</h3>
      <h3>交易時間: {{ invoiceSale.UploadTime }}</h3>
      <h3>開立方式: {{ invoiceDetail.type }}</h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getInvoiceAvalible, deleteInvoices, getInvoice, getInvoices } from '@/api/invoice';
import selectCompany from '@/components/select/companies';
const methods = {
  async onSelectCompany() {
    this.invoices = await getInvoices({
      company_id: this.company_id,
      status: 1,
    });
    this.currentPage = 1;
  },
  async init() {
    this.selected = [];
  },
  statusClass({ row, index }) {
    switch (row.Status) {
      case 0:
        return 'danger';
      default:
        return '';
    }
  },
  handleSelectionChange(rows) {
    this.selected = rows;
  },
  async deleteInvoices() {
    const data = await deleteInvoices(this.selected);
    if (data) {
      this.$message({
        message: '成功',
        type: 'success',
      });
    }
    this.init();
  },
  async handleDetail(row) {
    this.dialogVisible = true;
    const data = await getInvoice(row.id);
    this.invoice = data.invoice;
    this.invoiceDetail = this.invoice.detail;
    this.invoiceSale = data.sale;
  },

  async handleSizeChange(size) {
    this.size = size;
    this.invoices = await getInvoices({
      company_id: this.company_id,
      size: this.size,
      status: 1,
    });
  },
  async handleCurrentChange(page) {
    this.invoices = await getInvoices({
      company_id: this.company_id,
      page,
      size: this.size,
      status: 1,
    });
  },
};
export default {
  components: {
    selectCompany,
  },
  data() {
    return {
      invoices: [],
      selected: [],
      invoiceDetail: {},
      invoiceSale: {},
      invoice: {},
      currentPage: 1,
      size: 10,
      dialogVisible: false,
      company_id: null,
    };
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .danger {
  background: #5858583b;
}

.padding {
  padding: 1rem;
}
</style>
